import { render, staticRenderFns } from "./KnowledgeContentCheckbox.vue?vue&type=template&id=cf5e8dc4&"
import script from "./KnowledgeContentCheckbox.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports